var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 10H50.22C52.3076 10 54 11.6924 54 13.78V56.22C54 57.2225 53.6018 58.184 52.8929 58.8929C52.184 59.6018 51.2225 60 50.22 60H13.78C11.6924 60 10 58.3076 10 56.22V13.78C10 11.6924 11.6924 10 13.78 10H20V7.78C20 5.69236 21.6924 4 23.78 4H40.22C41.2225 4 42.184 4.39825 42.8929 5.10714C43.6018 5.81602 44 6.77748 44 7.78V10ZM40 8H24V16H40V8ZM50 56H14V14H20V20H44V14H50V56ZM34 40H30V48H34V40ZM40 36H44V48H40V36ZM24 28H20V48H24V28Z",
    fill: "#043F93"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 4,
    width: 44,
    height: 56
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 10H50.22C52.3076 10 54 11.6924 54 13.78V56.22C54 57.2225 53.6018 58.184 52.8929 58.8929C52.184 59.6018 51.2225 60 50.22 60H13.78C11.6924 60 10 58.3076 10 56.22V13.78C10 11.6924 11.6924 10 13.78 10H20V7.78C20 5.69236 21.6924 4 23.78 4H40.22C41.2225 4 42.184 4.39825 42.8929 5.10714C43.6018 5.81602 44 6.77748 44 7.78V10ZM40 8H24V16H40V8ZM50 56H14V14H20V20H44V14H50V56ZM34 40H30V48H34V40ZM40 36H44V48H40V36ZM24 28H20V48H24V28Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.e6cd42ab416e1f8d5a2db35003e7de3b.svg";
export { ForwardRef as ReactComponent };